/* eslint-disable max-len */
import React, {useState, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {Helmet} from 'react-helmet';
import styled from 'styled-components';

import {notWebMediaQuery, PageBodyWrapper, useBreakpoint} from '../styles';
import * as ShowActions from '../store/actions/show';

import Loader from '../components/Loader';
import ShowsGrid from '../components/ShowsGrid';
import {debugCNitoUrl, slugify} from '../helpers';

const Cartoons = props => {
    const {t} = useTranslation();
    const history = useHistory();
    const dispatch = useDispatch();
    const {user} = useSelector(state => state);
    const idp = user && user.idp;
    const breakpoint = useBreakpoint();

    props = {
        ...props,
        ...useSelector(state => {
            return {...state.show, ...state.user};
        }),
    };

    const [pageState, setPageState] = useState('loading');
    const [shows, setShows] = useState(undefined);
    const [showsLoaded, setShowsLoaded] = useState(false);
    const [sentPageview, setSentPageview] = useState(false);

    useEffect(() => {
        if (!sentPageview) {
            setSentPageview(true);

            window.turner_metadata.trackAction.push({
                type: 'pageview',
                data: {
                    pageName: `${window.location.hostname}/cartoons`,
                    section: 'Cartoons',
                    subsection: 'nvs',
                    contenttype: 'Cartoons',
                    contenttitle: 'Cartoons',
                    presentationtemplate: 'desktop',
                    platform: 'web',
                    domain: `web|${window.location.hostname}`,
                    region: 'latam',
                    country:
                        user && user.countryIsoCode && user.countryName
                            ? `${user.countryIsoCode.toLowerCase()}|${
                                  user.countryName
                              }`
                            : 'not loaded',
                    brand: 'cartoonito',
                    pageviewevent: 1,
                    authstate:
                        user && user.jwtToken
                            ? 'authenticated'
                            : 'unauthenticated',
                    mvpd: idp || 'idp not loaded',
                },
            });
        }

        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        (shows === undefined || shows.length === 0) && loadShows();

        setShowsLoaded(true);

        // eslint-disable-next-line
    }, [user.jwtToken]);

    useEffect(() => {
        if (props.shows !== undefined && showsLoaded) {
            setShows(props.shows);
        }

        //eslint-disable-next-line
    }, [props.shows, showsLoaded]);

    useEffect(() => {
        if (shows !== undefined) {
            setPageState('ready');
        }

        //eslint-disable-next-line
    }, [shows]);

    const loadShows = async () => {
        try {
            const shows_response = await dispatch(ShowActions.loadShows());

            if (
                shows_response.status === 200 &&
                shows_response.data?.data?.shows
            ) {
                setShows(shows_response.data.data.shows);
            } else {
                history.push(`/error${debugCNitoUrl()}`);
            }
        } catch (err) {
            // eslint-disable-next-line no-console
            console.log(err);
            history.push(`/error${debugCNitoUrl()}`);
        }
    };

    const handleClickIp = (show_title, item) => {
        history.push(`/cartoon/${slugify(show_title)}${debugCNitoUrl()}`);
    };

    let renderPage = React.useMemo(() => {
        if (pageState !== 'ready') {
            return <Loader margin="auto" />;
        } else {
            return (
                <ShowsGrid items={shows} onClickItem={handleClickIp} cnito />
            );
        }

        // eslint-disable-next-line
    }, [shows, pageState, breakpoint]);

    return (
        <>
            <Helmet>
                <title>{t('cartoonito.cartoons.metaTitle')}</title>
                <meta
                    name="description"
                    content={t('cartoonito.cartoons.metaDescription')}
                />
            </Helmet>

            <Container>
                <div>{renderPage}</div>
            </Container>
        </>
    );
};

const Container = styled(PageBodyWrapper)`
    margin-left: 0;
    margin-right: 0;
    max-width: 100%;
    position: relative;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    padding-bottom: 80px;
    min-height: calc(100vh - 392px);
    width: 100%;
    box-sizing: border-box;
    background-color: #0066ff;
    padding-top: 80px;

    ${notWebMediaQuery} {
        padding-bottom: 32px;
    }

    & > div {
        flex: 1;
        width: 100%;
        max-width: 1440px;
        margin-left: auto;
        margin-right: auto;
    }
`;

export default Cartoons;
